import { listPlayers } from "services/send-email.service";

export function useListPlayer(){
    const listPlayer = async () => {
        try{
            const data = await listPlayers();
            return data;
        }catch (error) {
            console.error("Erro ao listar jogadores:", error);
            throw error;
        }
    }

    return { listPlayer };
}